
import { Link, useNavigate } from "react-router-dom";
import { Building2, Phone, Menu } from "lucide-react";
import { Button } from "./ui/button";
import { useState, useEffect } from "react";

export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  // Close menu when route changes
  useEffect(() => {
    return () => setIsMenuOpen(false);
  }, [navigate]);

  const handleHomeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    // Navigate to home and reset all filters
    navigate('/', { 
      replace: true,
      state: { resetFilters: true } 
    });
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-[#174996] text-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-2" onClick={handleHomeClick}>
            <Building2 className="h-6 w-6" />
            <span className="text-xl font-bold">Home Pros OKC</span>
          </Link>
          
          <Button
            variant="ghost"
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <Menu className="h-6 w-6" />
          </Button>

          <nav className={`${
            isMenuOpen ? 'flex' : 'hidden'
          } md:flex absolute md:relative top-full left-0 right-0 md:top-auto bg-[#174996] md:bg-transparent flex-col md:flex-row items-center space-y-4 md:space-y-0 pb-4 md:pb-0 w-full md:w-auto md:space-x-8 z-50`}>
            <Link 
              to="/services" 
              className="text-white/80 hover:text-white transition-colors px-4 py-2 md:py-0"
              onClick={() => setIsMenuOpen(false)}
            >
              Featured Services
            </Link>
            <Link 
              to="/for-pros" 
              className="text-white/80 hover:text-white transition-colors px-4 py-2 md:py-0"
              onClick={() => setIsMenuOpen(false)}
            >
              For Pros
            </Link>
            <Link 
              to="/about" 
              className="text-white/80 hover:text-white transition-colors px-4 py-2 md:py-0"
              onClick={() => setIsMenuOpen(false)}
            >
              About Us
            </Link>
            <Link 
              to="/contact" 
              className="text-white/80 hover:text-white transition-colors px-4 py-2 md:py-0"
              onClick={() => setIsMenuOpen(false)}
            >
              Contact Us
            </Link>
          </nav>
          
          <Button asChild variant="outline" className="hidden md:flex items-center gap-2 bg-white text-[#174996] hover:bg-white/90">
            <a href="tel:+14059726779">
              <Phone className="h-4 w-4" />
              <span>Start Your Project</span>
            </a>
          </Button>
        </div>

        {/* Mobile CTA Button */}
        <div className="md:hidden mt-4 flex justify-center">
          <Button asChild variant="outline" className="w-full bg-white text-[#174996] hover:bg-white/90">
            <a href="tel:+14059726779">
              <Phone className="h-4 w-4 mr-2" />
              <span>Start Your Project</span>
            </a>
          </Button>
        </div>
      </div>
    </header>
  );
};
